import React, { PropsWithChildren } from 'react';
import { Outlet, useParams } from 'react-router';
import { InspectionProvider } from '../../contexts/inspection';

export const InspectionContainer: React.FC<PropsWithChildren> = ({
  children
}) => {
  const params = useParams();
  return (
    <InspectionProvider id={params.id}>
      {children}
      <Outlet />
    </InspectionProvider>
  );
};
